import { BrowserRouter } from "react-router-dom";
import React from "react";
import { render } from "react-dom";
import { datadogRum } from "@datadog/browser-rum";
import { initDataDogRUM } from "./utils/datadogInit";
import App from "./App";

const initialState = window?._INITIAL_DATA_;

//Instantiate DataDog RUM
initDataDogRUM(datadogRum, initialState);

/* eslint react/no-deprecated: 0 */
// overrides eslint react/no-deprecated rule since we're not on React 18 yet
render(
  <BrowserRouter>
    <App configData={initialState} />
  </BrowserRouter>,
  document.getElementById("root")
);

if (module.hot) {
  module.hot.accept();
}
